import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If the DOM was pre-rendered (has any element children), hydrate — else render.
if (container.firstElementChild) {
    hydrateRoot(
        container,
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
} else {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}
